import React from 'react';
import './testimonial.css';
import Image1 from '../../assets/avatar-1.svg';
import Image3 from '../../assets/avatar-3.svg';
import { SwiperSlide, Swiper } from 'swiper/react';
import 'swiper/css';
import { Pagination } from 'swiper';
import 'swiper/css/pagination';

const data = [
  {
    id: 1,
    image: Image1,
    title: "Rizal Rahman",
    subtitle: "Student at University State of Makassar",
    comment:
      "I enjoy working with the theme and learn so much. You make the process fun and interesting. Good luck! 👍",
  },
  {
    id: 2,
    image: Image3,
    title: "Azyumardi Azra",
    subtitle: "Student at University State of Makassar",
    comment:
      "I enjoy working with the theme and learn so much. You make the process fun and interesting. Good luck! 👍",
  },
];

const Testimonial = () => {
  return (
    <section className="testimonials container section">
      <h2 className="section_title">Clients & Reviews</h2>

      <Swiper className="testimonials_container grid"
      modules={[ Pagination ]}
      spaceBetween={30}
      slidesPerView={1}
      loop={true}
      grabCursor={true}
      pagination={{ clickable: true }}>
        {data.map(({id, image, title, subtitle, comment}) => {
          return (
            <SwiperSlide className="testimonial_item" key={id}>
              <div className="thumb">
                <img src={image} alt="" />
              </div>
              <h3 className="testimonial_title">{title}</h3>
              <span className="subtitle">{subtitle}</span>
              <div className="comment">{comment}</div>
            </SwiperSlide>
          )
        })}
      </Swiper>
    </section>
  )
}

export default Testimonial